module.exports = __webpack_public_path__ + "img/greengrass1.214f147e.jpg";